import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';

export default class RemoveFromListTaskModal extends React.Component {
  static propTypes = {
    callList: PropTypes.object.isRequired,
    shown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
  };

  render() {
    const { callList, shown, onCancel, onDelete } = this.props;

    return (
      <Modal
        className='contact-modal overflow-visible'
        name='task-delete-modal'
        show={shown}
        onHide={onCancel}
      >
        <Modal.Header closeButton>
          <Modal.Title>Remove Task from List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>Are you sure you want to remove this task from {callList.name}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-sm btn-cancel' onClick={onCancel}>Cancel</button>
          <button
            className='btn btn-sm btn-danger'
            onClick={onDelete}
          >
              Remove
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
